/* A member's admin roles, one line per kind: a Room Parent tag and the classes
   they run, a Group Admin tag and the sub-groups they run — what they run, not
   everything they joined. Shared by the Master dashboard and the Directory. */

/* true only when the API said which networks they run and there's at least one */
export const hasAdminRole = (m) => !!(m?.adminClasses?.length || m?.adminGroups?.length);

export default function AdminRoleLines({ member }) {
  if (!hasAdminRole(member)) return null;
  const { adminClasses, adminGroups } = member;
  return (
    <>
      {!!adminClasses.length && (
        <div className="rp-admin-line">
          <span className="src-chip">Room Parent</span>
          <span>{adminClasses.map((n) => n.name).join(', ')}</span>
        </div>
      )}
      {!!adminGroups.length && (
        <div className="rp-admin-line">
          <span className="src-chip group">Group Admin</span>
          <span>{adminGroups.map((n) => n.name).join(', ')}</span>
        </div>
      )}
    </>
  );
}
